module.exports = __webpack_public_path__ + "prod/1.42.2/img/renrenCar-icon.bb4f69a5.png";